import { useEffect } from 'react';
import { init } from '@mutiny-pkg/analytics-tracker/src/index';

type AnalyticsPageViewProps = {
  endpoint?: string;
  companyId?: string;
  assetId?: string;
  preview?: boolean;
};

export function AnalyticsPageView({ endpoint, companyId, assetId, preview }: AnalyticsPageViewProps) {
  useEffect(() => {
    if (preview || !endpoint || !companyId || !assetId) {
      return;
    }

    init({
      endpoint,
      companyId,
      assetId,
    });
  }, [assetId, companyId, endpoint, preview]);

  return null;
}
